.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
}

.title {
  font-size: 20px;
  font-weight: 400;
  margin: 0;
  color: #505050;
}

.subtitle {
  font-size: 14px;
  font-weight: 300;
  color: #727272;
  margin: 0;
  text-align: center;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 360px;
}

.input {
  font-family: 'Onest', sans-serif;
  font-size: 14px;
  font-weight: 300;
  padding: 12px 16px;
  border: 1px solid #d0d0d0;
  border-radius: 12px;
  outline: none;
  color: #505050;
  background: #fff;
  transition: border-color 0.2s;
}

.input:focus {
  border-color: #505050;
}

.input::placeholder {
  color: #aaa;
}

.inputError {
  border-color: #e74c3c;
}

.errorText {
  color: #e74c3c;
  font-size: 12px;
  margin: -6px 0 0;
}

/* Phone row with fixed +373 prefix */
.phoneRow {
  display: flex;
  align-items: center;
  border: 1px solid #d0d0d0;
  border-radius: 12px;
  background: #fff;
  transition: border-color 0.2s;
  overflow: hidden;
}

.phoneRow:focus-within {
  border-color: #505050;
}

.phonePrefix {
  font-family: 'Onest', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #505050;
  padding: 12px 0 12px 16px;
  user-select: none;
  flex-shrink: 0;
}

.phoneInput {
  font-family: 'Onest', sans-serif;
  font-size: 14px;
  font-weight: 300;
  color: #505050;
  border: none;
  outline: none;
  background: transparent;
  padding: 12px 16px 12px 6px;
  flex: 1;
  min-width: 0;
}

.phoneInput::placeholder {
  color: #aaa;
}

/* Textarea for comment */
.textarea {
  font-family: 'Onest', sans-serif;
  font-size: 14px;
  font-weight: 300;
  padding: 12px 16px;
  border: 1px solid #d0d0d0;
  border-radius: 12px;
  outline: none;
  color: #505050;
  background: #fff;
  transition: border-color 0.2s;
  resize: vertical;
  min-height: 60px;
}

.textarea:focus {
  border-color: #505050;
}

.textarea::placeholder {
  color: #aaa;
}

/* Photo attachments */
.attachSection {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.attachButton {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: 'Onest', sans-serif;
  font-size: 13px;
  font-weight: 300;
  color: #727272;
  background: none;
  border: 1px dashed #d0d0d0;
  border-radius: 10px;
  padding: 8px 14px;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.attachButton:hover {
  border-color: #505050;
  color: #505050;
}

.attachIcon {
  font-size: 18px !important;
  transform: rotate(45deg);
}

.thumbnails {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.thumbnail {
  position: relative;
  width: 56px;
  height: 56px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.thumbnailRemove {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.thumbnailRemove:hover {
  background: rgba(0, 0, 0, 0.8);
}

.configLink {
  font-size: 12px;
  color: #aaa;
  word-break: break-all;
  text-align: center;
  margin: 0;
}

.successContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px 0;
}

.successIcon {
  color: #4caf50;
  font-size: 48px !important;
}

.successTitle {
  font-size: 20px;
  font-weight: 400;
  color: #505050;
  margin: 0;
}

.successText {
  font-size: 14px;
  font-weight: 300;
  color: #727272;
  margin: 0;
  text-align: center;
}
